/**
 * Logic per oneri
 */
export class BurdensLogic {
  /**
   * Ritorna vero se la configurazione non richiede di nascondere
   * le funzionalità relative agli oneri. (gestisce solo UI)
   */
  static isVisible() {
    return process.env.HIDE_BURDENS !== 'true';
  }
}
